var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.166 4.66602C15.166 4.94216 14.9422 5.16602 14.666 5.16602L1.33268 5.16602C1.05654 5.16602 0.832682 4.94216 0.832682 4.66602C0.832682 4.38987 1.05654 4.16602 1.33268 4.16602L14.666 4.16602C14.9422 4.16602 15.166 4.38987 15.166 4.66602Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.166 8C13.166 8.27614 12.9422 8.5 12.666 8.5L3.33268 8.5C3.05654 8.5 2.83268 8.27614 2.83268 8C2.83268 7.72386 3.05654 7.5 3.33268 7.5L12.666 7.5C12.9422 7.5 13.166 7.72386 13.166 8Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.166 11.334C11.166 11.6101 10.9422 11.834 10.666 11.834H5.33268C5.05654 11.834 4.83268 11.6101 4.83268 11.334C4.83268 11.0578 5.05654 10.834 5.33268 10.834H10.666C10.9422 10.834 11.166 11.0578 11.166 11.334Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.68a50f6df804d19036a4a20e9ebf6f1d.svg";
export { ForwardRef as ReactComponent };